import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useAuthenticatedFileUrl } from "../../hooks/useAuthenticatedFileUrl";

type AuthenticatedFileLinkProps = {
  href?: string | null;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  download?: string;
  target?: string;
  rel?: string;
};

export const AuthenticatedFileLink: React.FC<AuthenticatedFileLinkProps> = ({
  href,
  children,
  sx,
  download,
  target = "_blank",
  rel = "noopener noreferrer",
}) => {
  const { url } = useAuthenticatedFileUrl(href ?? undefined);

  if (!href || !url) {
    return <Box sx={sx}>{children}</Box>;
  }

  return (
    <Box
      component="a"
      href={url}
      target={target}
      rel={rel}
      download={download}
      sx={sx}
    >
      {children}
    </Box>
  );
};
